"use client"

import { Image } from "@/app/components/image"
import { PriceInCrypto } from "@/app/price"
import type { Nft } from "@anaconda/core/nft/types"
import { Trans, useLingui } from "@lingui/react/macro"
import { Card } from "@rarible_int/anaconda_ui_components"

interface Props {
  nft: Nft
}

export function ItemPreview({ nft }: Props) {
  const { t } = useLingui()

  return (
    <Card className="flex w-full min-w-0 flex-col gap-4 p-4">
      <div className="flex w-full min-w-0 items-center gap-3">
        <div className="h-10 w-10 shrink-0">
          <Image imageSrc={nft.image} alt={t`Image for ${nft.name}`} />
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <span className="truncate">{nft.name}</span>
          <div className="flex min-w-0 flex-wrap items-center gap-[10px] text-foreground/60 text-xs">
            <span className="truncate">{nft.collection.name}</span>
            {nft.price && (
              <span>
                <Trans>Listed for</Trans> <PriceInCrypto {...nft.price} />
              </span>
            )}
          </div>
        </div>
      </div>
    </Card>
  )
}
